import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import {
  PaginatedList,
  RelacaoGanhadoresSorteio,
  SituacaoSorteioModel,
  SorteioModel,
  TipoSorteioModel,
} from '../../../shared';
import { SorteioService } from '../shared/sorteio.service';

@Component({
  selector: 'app-relacao-ganhadores',
  templateUrl: './relacao-ganhadores.component.html',
  styleUrls: ['./relacao-ganhadores.component.css']
})
export class RelacaoGanhadoresComponent implements OnInit {
  @Input() public paginaSorteio: number;
  @Input() public tamanhoSorteio: number;

  public totalRegistrosSorteioMensal: number;
  public sorteiosMensal: Array<SorteioModel>;

  public totalRegistrosSorteioEspecial: number;
  public sorteiosEspecial: Array<SorteioModel>;

  public _tiposSorteio: Array<TipoSorteioModel>;
  public situacoesSorteio: Map<number, Array<SituacaoSorteioModel>>;
  
  public premiados: Array<RelacaoGanhadoresSorteio>;

  public carregando: string;

  constructor(private readonly sorteioService: SorteioService, 
    private readonly sorteioEspecialService: 
    SorteioService, private readonly router: Router) {
    this.totalRegistrosSorteioMensal = 0;
    this.totalRegistrosSorteioEspecial = 0;
  }

  public get tiposSorteio(): Array<TipoSorteioModel> {
    return this._tiposSorteio;
  }

  public set tiposSorteio(v: Array<TipoSorteioModel>) {
    this._tiposSorteio = v;
  }

  ngOnInit() {
    this.paginaSorteio = 1;
    this.tamanhoSorteio = 10;

    this.tiposSorteio = new Array<TipoSorteioModel>();

    this.sorteiosMensal = new Array<SorteioModel>();
    this.sorteiosEspecial = new Array<SorteioModel>();

    this.premiados = new Array<RelacaoGanhadoresSorteio>();

    this.getTiposSorteio();

    this.sorteioService.tiposSorteioChange.subscribe((data: Array<TipoSorteioModel>) => {
      this.tiposSorteio = data;
    });

    this.ObterListagemSorteiosMensal(this.paginaSorteio, this.tamanhoSorteio);
    this.ObterListagemSorteiosEspecial(this.paginaSorteio, this.tamanhoSorteio);
  }

  private ObterListagemSorteiosMensal(paginaSorteio : number, tamanhoSorteio : number) {

    // Obtem a lista de sorteios mensais.
    this.sorteioService.getSorteiosRealizados(paginaSorteio, tamanhoSorteio, 1)
    .subscribe((data: PaginatedList<SorteioModel>) => {
      this.totalRegistrosSorteioMensal = data.totalCount;
      this.sorteiosMensal = data.list;
    });
  }

private ObterListagemSorteiosEspecial(paginaSorteio : number, tamanhoSorteio : number) {
   
    // Obtem a lista de sorteios Especiais.
    this.sorteioEspecialService.getSorteiosRealizados(paginaSorteio, tamanhoSorteio, 2)
    .subscribe((data: PaginatedList<SorteioModel>) => {
      this.totalRegistrosSorteioEspecial = data.totalCount;
      this.sorteiosEspecial = data.list;
    });
  }

  public getEnderecoRelacaoGanhadoresPDF(nomeArquivo) {
    return this.sorteioService.uriDocsnbp + nomeArquivo;
  }

  public getTiposSorteio(): void {
    this.sorteioService.getTiposSorteio();
  }

  public getDescricaoTipoSorteio(seqTipo: number): string {
    return this._tiposSorteio.find(t => t.codTipoSorteioPremiacaoConsumidor === seqTipo).desTipoSorteioPremiacaoConsumidor;
  }

  public gerarRelatorio(seqSorteio: number): void {
    this.sorteioService.getRelatorioRelacaoPremiados(seqSorteio);
  }

  public pageChangeMensal(event: number): void {
    this.ObterListagemSorteiosMensal(event, this.tamanhoSorteio);
  }

  public pageChangeEspecial(event: number): void {
    this.ObterListagemSorteiosEspecial(event, this.tamanhoSorteio);
  }
}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/relacao-ganhadores/relacao-ganhadores.component.ts